// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2mvuU","header":"PatientQuestionnaire_header__33ZdW","info":"PatientQuestionnaire_info__3BWPz"};